import api from "./api";

// eslint-disable-next-line import/prefer-default-export
export const newUser = data => api.post("/users", data);



// WEBPACK FOOTER //
// ./src/util/users.js